import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root', // This will provide the service globally (no need to add it to 'providers' in your module)
})
export class TranslationService {
  
  private apiUrl = 'https://api.cognitive.microsofttranslator.com/translate?api-version=3.0&from=en&to=hi';
  private subscriptionKey = 'ed6d0a7a2cba460ab8de7529aa4ab772'; // Replace with your actual subscription key
  private subscriptionRegion = 'centralindia'; // Replace with your actual region

  constructor(private http: HttpClient) {}

  translateText(text: string): Observable<any> {
    const headers = new HttpHeaders({
      'Ocp-Apim-Subscription-Key': this.subscriptionKey,
      'Ocp-Apim-Subscription-Region': this.subscriptionRegion,
      'Content-Type': 'application/json',
    });

    const body = [{ Text: text }];

    return this.http.post<any>(this.apiUrl, body, { headers });
  }
}
